import styled from "styled-components";
const leftTooltip = ({ bottom = 0, left = 0 }) => `
                     right: calc(100% + ${left}px);
                     top: calc(0.1rem + ${bottom}px);
                     margin-left:0.75rem`;
const topTooltip = ({ top = 0, right = 0 }) => `
                    bottom: calc(70% + ${top}px);
                    left:calc(50% + ${right}px);
                    margin-bottom: 0.75rem;
                    transform: translateX(-50%);`;
const bottomTooltip = ({ right = 0, bottom = 0 }) => `
                      top: calc(70% + ${bottom}px);
                      left: calc(50% + ${right}px);
                      margin-top: 0.75rem;
                      transform: translateX(-50%);`;
const rightTooltip = ({ right = 0, bottom = 0 }) => `
                      left: calc(100% + ${right}px);
                      top: calc(0.1rem + ${bottom}px);
                      margin-right: 0.75rem`;
const topLeftTooltip = ({ top = 0, left = 0 }) => `
                      bottom: calc(70% + ${top}px);
                      right: calc(-0.325rem + ${left}px);
                      margin-bottom: 0.75rem;`;
const bottomLeftTooltip = ({ bottom = 0, left = 0 }) => `
                      top: calc(70% + ${bottom}px);
                      right: calc(-0.325rem + ${left}px) ;
                      margin-top: 0.75rem;`;
const topRightTooltip = ({ top = 0, right = 0 }) => `
                    bottom: calc(70% + ${top}px);
                    left: calc(-0.325rem + ${right}px);
                    margin-bottom: 0.75rem;`;
const bottomRightTooltip = ({ right = 0 }) => `
                    left: calc(-0.325rem + ${right}px) ;
                    margin-top: 0.75rem;`;
function getPosition({ tooltipPosition, offset }) {
    if (tooltipPosition === "left") {
        return leftTooltip(offset);
    }
    if (tooltipPosition === "right") {
        return rightTooltip(offset);
    }
    if (tooltipPosition === "top") {
        return topTooltip(offset);
    }
    if (tooltipPosition === "bottom") {
        return bottomTooltip(offset);
    }
    if (tooltipPosition === "topRight") {
        return topRightTooltip(offset);
    }
    if (tooltipPosition === "bottomRight") {
        return bottomRightTooltip(offset);
    }
    if (tooltipPosition === "topLeft") {
        return topLeftTooltip(offset);
    }
    if (tooltipPosition === "bottomLeft") {
        return bottomLeftTooltip(offset);
    }
    return leftTooltip(offset);
}
const arrowTop = (theme) => `
        bottom: 100%; 
        height: 0;
        width: 0;
        left: 47%;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-bottom: 0.5rem solid ${theme.colors.grey15};`;
const arrowTopShort = (theme) => `
        bottom: 100%; 
        height: 0;
        width: 0;
        left: 44%;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-bottom: 0.5rem solid ${theme.colors.grey15};`;
const arrowTopLong = (theme) => `
        bottom: 100%; 
        left: 7.875rem;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-bottom: 0.5rem solid ${theme.colors.grey15};`;
const arrowDown = (theme) => `
        top: 100%;
        left: 47%;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-top: 0.5rem solid ${theme.colors.grey15};`;
const arrowDownShort = (theme) => `
        top: 100%;
        left: 44%;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-top: 0.5rem solid ${theme.colors.grey15};`;
const arrowDownLong = (theme) => `
        top: 100%;
        left: 7.875rem;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-top: 0.5rem solid ${theme.colors.grey15};`;
const arrowLeft = (theme) => `
        top: 34%;
        left: 100%;
        height: 0;
        width: 0;
        ${({ promptText }) => (promptText.length > 36 ? `` : `top: 34%`)};
        border-top: 0.375rem solid transparent;
        border-bottom: 0.375rem solid transparent;
        border-left: 0.5rem solid ${theme.colors.grey15};`;
const arrowLeftLong = (theme) => `
        top: 0.8rem;
        left: 100%;
        height: 0;
        width: 0;
        ${({ promptText }) => (promptText.length > 36 ? `top: 0.5rem;` : ``)};
        border-top: 0.375rem solid transparent;
        border-bottom: 0.375rem solid transparent;
        border-left: 0.5rem solid ${theme.colors.grey15};`;
const arrowRight = (theme) => `
        top: 34%;
        right: 100%;
        height: 0;
        width: 0;
        border-top: 0.375rem solid transparent;
        border-bottom: 0.375rem solid transparent;
        border-right:0.5rem solid ${theme.colors.grey15};`;
const arrowRightLong = (theme) => `
        top: 0.8rem;       
        right: 100%;
        height: 0;
        width: 0;
        border-top: 0.375rem solid transparent;
        border-bottom: 0.375rem solid transparent;
        border-right:0.5rem solid ${theme.colors.grey15};`;
const arrowTopRight = (theme) => `
        bottom: 100%;
        right: 1.2rem;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-bottom: 0.5rem solid ${theme.colors.grey15};`;
const arrowTopLeft = (theme) => `
        bottom: 100%;
        left: 1.2rem;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-bottom: 0.5rem solid ${theme.colors.grey15};`;
const arrowDownLeft = (theme) => `
        top: 100%;
        left: 1.2rem;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-top: 0.5rem solid ${theme.colors.grey15};`;
const arrowDownRight = (theme) => `
        top: 100%;
        right: 1.2rem;
        height: 0;
        width: 0;
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-top: 0.5rem solid ${theme.colors.grey15};`;
function getTrianglePosition({ tooltipPosition, promptText, theme, }) {
    if (tooltipPosition === "left") {
        return promptText.length > 36 ? arrowLeftLong(theme) : arrowLeft(theme);
    }
    if (tooltipPosition === "right") {
        return promptText.length > 36 ? arrowRightLong(theme) : arrowRight(theme);
    }
    if (tooltipPosition === "top") {
        if (promptText.length > 36) {
            return arrowDownLong(theme);
        }
        if (promptText.length < 12) {
            return arrowDownShort(theme);
        }
        return arrowDown(theme);
    }
    if (tooltipPosition === "bottom") {
        if (promptText.length > 36) {
            return arrowTopLong(theme);
        }
        if (promptText.length < 12) {
            return arrowTopShort(theme);
        }
        return arrowTop(theme);
    }
    if (tooltipPosition === "bottomRight") {
        return arrowTopLeft(theme);
    }
    if (tooltipPosition === "bottomLeft") {
        return arrowTopRight(theme);
    }
    if (tooltipPosition === "topRight") {
        return arrowDownLeft(theme);
    }
    if (tooltipPosition === "topLeft") {
        return arrowDownRight(theme);
    }
    return arrowLeft(theme);
}
//  word-break: break-all;
export const TooltipPromptContainer = styled.div `
  position: absolute;
  ${getPosition};
  max-width: 15rem;
  ${({ promptText }) => promptText.length > 36
    ? `word-wrap: break-word; width: 15rem;`
    : `white-space: pre`};
  z-index: 1;
  background: ${({ theme }) => theme.colors.grey15};
  filter: drop-shadow(
    0 0.125rem 0.0625rem
      rgb(${({ theme }) => theme.colors.transparentBlack}, 0.36)
  );
  will-change: filter;
  font-family: "AktivGrotesk";
  font-style: normal;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.white};
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  &:after {
    content: "";
    position: absolute;
    ${({ tooltipPosition, promptText, theme }) => getTrianglePosition({ tooltipPosition, promptText, theme })};
    z-index: 1;
  }
`;
